PJQ.views.settings.CompanyInfo = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Company-Info'),
		subTemplates: {
			subscription: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'subscription-info'),
		},
		onChange: null
	},
	events: {
		"mouseup .btn-password-reset-modal": "resetPasswordModal",
		'change .cb-directory-status': 'directoryStatusChanged',
		"keyup input[type='text']": "onChange",
		'change .user-procore-link': 'procoreLink',
		'click .btn-join-directory': 'joinDirectory',
		'click .btn-enable-auto-renew': 'enableAutoRenew',
		'click .btn-disable-auto-renew': 'disableAutoRenew',
		'click .btn-edit-card': 'changeCard'
	},
	beforeFirstRender: function () {
		if (this.options.procoreCode)
			PJQ.app.session.preferences.setPref(PJQ.constants.preferenceTypes.PROCORE_ACCESS_REFRESH_TOKEN, 'code:' + this.options.procoreCode);

		this.model = PJQ.app.session.user;
		if (!this.model.isFetched) {
			this.model.fetch({
				success: _.bind(function () {
					this.render();
					this.listenTo(this.model, 'fetch', this.render);
				}, this)
			});
		}
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model
		}
	},
	afterRender: function () {
		if (this.model == null || !this.model.isFetched) {
			return;
		}

		PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.input-user-phone'));
		PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.input-user-cell'));
		PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.input-user-fax'));

		if (PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId) {
			new PJQ.inputs.Selectpicker({
				el: this.$('.select-company-type'),
				hideDisabled: true,
				defaultValue: this.model.get('companyType'),
				onChange: _.bind(function (value) {
					this.model.set('companyType', value);
					this.onChange();
				}, this)
			});
		}

		this.statePicker = new PJQ.inputs.Selectpicker({
			el: this.$('.user-edit-state'),
			defaultValue: _.size(this.model.get('state')) > 0 ? this.model.get('state').toLowerCase() : null,
			onChange: _.bind(function (value) {
				this.model.set('state', value.toUpperCase());
				this.onChange();
			}, this)
		});
		this.countryChanged();

		new PJQ.inputs.Selectpicker({
			el: this.$('.user-edit-country'),
			noneSelectedText: 'Select Value',
			defaultValue: _.size(this.model.get('country')) > 0 ? this.model.get('country').toLowerCase() : null,
			onChange: _.bind(function (value) {
				this.model.set('country', value.toUpperCase());
				this.model.set('zip', '');
				this.model.set('state', '');
				this.countryChanged();
				this.onChange();
			}, this)
		});

		$(function () {
			$('[data-toggle="tooltip"]').tooltip()
		});
		new PJQ.Binder(this.$el, this.model, {
			afterChange: _.bind(function () {
				this.onChange();
			}, this)
		});

		if (this.options.procoreCode) {
			PJQ.notifications.notify.successNotify({
				message: 'Your Procore login has been linked to your Pantera account.'
			});
			this.options.procoreCode = null;
		}

		if (PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId) {
			this.renderSubscriptionInfo();
			this.renderDirectoryStatus();
		}
	},
	directoryStatusChanged: function (e) {
		let isActive = $(e.currentTarget).prop('checked');
		if (isActive) {
			this.joinDirectory();
		}
		else {
			this.leaveDirectory();
		}
	},
	joinDirectory: function () {
		PJQ.app.session.joinDirectory(_.bind(function () {
			this.$(".directory-alert").remove();
			this.renderDirectoryStatus();
		}, this));
	},
	leaveDirectory: function () {
		PJQ.app.session.leaveDirectory(_.bind(function () {
			this.renderDirectoryStatus();
		}, this));
	},
	renderDirectoryStatus: function () {
		let isActive = PJQ.app.session.contact != null && !PJQ.app.session.contact.get('isBlacklisted');
		this.$('.directory-status-label').html(isActive ? 'Active' : 'Inactive').css('color', isActive ? PJQ.constants.colors.GREEN : PJQ.constants.colors.RED);
		this.$('.cb-directory-status').prop('checked', isActive);
	},
	onChange: function () {
		if (typeof this.options.onChange === 'function') {
			this.options.onChange(this.model);
		}
	},
	renderSubscriptionInfo: function () {
		if (!PJQ.app.session.get('onAccount') && PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId) {
			PJQ.app.session.listenSubscriptionChanged("accountSettings", _.bind(function () {
				this.renderSubscriptionInfo();
			}, this));
			PJQ.app.session.fetchBillingInfo(_.bind(function (billingInfo) {
				this.renderSubTemplate(false, this.options.subTemplates.subscription, this.$('.subscription-info'), {
					subscription: PJQ.app.session.subscription,
					billingInfo: billingInfo
				});
			}, this));
		}
	},
	enableAutoRenew: function () {
		PJQ.app.session.updateAutoRenew(true, _.bind(function () {
			this.renderSubscriptionInfo();
			PJQ.notifications.notify.successNotify({
				message: "Auto renew successfully enabled"
			});
		}, this), _.bind(function () {
			PJQ.notifications.notify.errorNotify({
				message: "Encountered an error enabling auto renew.  Please contact customer service,"
			});
		}, this));
	},
	disableAutoRenew: function () {
		new PJQ.views.subscriptions.DisableAutoRenewModal({
			subscription: PJQ.app.session.subscription,
			onYes: _.bind(function () {
				PJQ.app.session.updateAutoRenew(false, _.bind(function () {
					this.renderSubscriptionInfo();
					PJQ.notifications.notify.successNotify({
						message: "Auto renew successfully disabled"
					});
				}, this), _.bind(function () {
					PJQ.notifications.notify.errorNotify({
						message: "Encountered an error disabling auto renew.  Please contact customer service,"
					});
				}, this));
			}, this)
		});
	},
	changeCard: function () {
		PJQ.app.session.fetchBillingInfo(_.bind(function (billingInfo) {
			new PJQ.views.payment.PaySimplePaymentModal({
				model: billingInfo,
				onSave: _.bind(function () {
					this.renderSubscriptionInfo();
					PJQ.notifications.notify.successNotify({
						message: "You have successfully updated your card on file."
					});
				}, this),
				onError: function () {
					PJQ.notifications.notify.errorNotify({
						message: "Encountered an error updating your card.  Please contact customer service."
					});
				}
			});
		}, this));
	},
	resetPasswordModal: function () {
		new PJQ.views.settings.ResetPasswordModal();
	},
	countryChanged: function () {
		let country = _.size(this.model.get('country')) > 0 ? this.model.get('country').toLowerCase() : 'us',
			options = '<option value="">Select Value</option>';
		_.each(PJQ.constants.states[country], function (state) {
			options += '<option value="' + state.abbreviation.toLowerCase() + '">' + state.name + '</option>';
		});
		this.statePicker.$el.html(options);
		this.statePicker.refresh();
		if (_.size(this.model.get('state')) > 0)
			this.statePicker.setValue(this.model.get('state').toLowerCase());

		PJQ.helpers.inputHelpers.inputMaskZip(this.$('.user-edit-zip'), country);
	},
	validate: function () {
		let errors = 0;
		let isValid = true;

		let isCompanyValid = _.size(this.model.get('companyName').trim()) > 0;
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-user-company-name'), isCompanyValid);
		isValid = isCompanyValid && isValid;
		if (!isValid) {
			errors += 1
		}

		return !!(isValid && errors === 0);
	},
	procoreLink: function () {
		let isLinked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROCORE_ACCESS_REFRESH_TOKEN);
		if (isLinked) {
			new PJQ.views.modals.YesNo({
				header: "Remove Procore User Link?",
				body: "Are you sure you would like to remove your link between Pantera and Procore? ",
				onYes: _.bind(function () {

					new PJQ.ajax.Request({
						endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
							{
								endpoint: 'integration'
							},
							{
								endpoint: 'procore'
							},
							{
								endpoint: 'unlink'
							}
						])
					}).post().done(_.bind(function (data) {
						PJQ.app.session.preferences.deletePref(PJQ.constants.preferenceTypes.PROCORE_ACCESS_REFRESH_TOKEN);
						PJQ.notifications.notify.successNotify({
							message: 'Your Procore login has been unlinked from your Pantera account.'
						});
					}, this));

				}, this),
				onNo: _.bind(function () {
					this.$('.user-procore-link').prop('checked', true);
				}, this)
			});

		}
		else {
			new PJQ.views.modals.YesNo({
				header: "Link Procore Account",
				body: "Are you sure you want to link your Procore account?  Please note this will redirect you to Procore to sign in and authorize the link.",
				onYes: _.bind(function () {
					let redirect = window.location.origin + '?procore=' + PJQ.app.session.user.id.toString(),
						url = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROCORE_URL_AUTH) + '/oauth/authorize?response_type=code&client_id=' + PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROCORE_CLIENT_ID) + '&redirect_uri=' + encodeURIComponent(redirect);
					document.location = url;
				}, this),
				onNo: _.bind(function () {
					this.$('.user-procore-link').prop('checked', false);
				}, this)
			});

		}
	}
});

PJQ.views.settings.ResetPasswordModal = PJQ.views.BaseModal.extend({
	baseOptions: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Modal-Reset-Password'),
		isVerticalCenter: false,
		isShowResetButton: true,
		resetButtonText: "Reset Password",
		resetButtonColorClass: 'primary',
		isShowCancelButton: true,
		cancelButtonText: "Close",
		onReset: _.noop,
		width: null,
		minWidth: null,
		maxWidth: null,
		height: null,
		minHeight: null,
		maxHeight: null,
		fitHeight: false
	},
	defaults: {},
	options: {},
	defaultEvents: {
		'hidden.bs.modal': 'removeModal',
		'click .modal-reset': 'onReset',
		'click .show-hide': 'showHide',
		'click .show-hide-confirm': 'showHide'
	},
	events: {},
	beforeFirstRender: function () {
		this.options = _.defaults(this.options, {
			uuid: "modal-" + _.uniqueId()
		});
		//force element to null in case one was passed in
		//this view uses modals only so it creates its own container to insert into in the <body>
		this.createModal();
		this.afterModalCreated();
	},
	onReset: function () {
		if (this.errorAlert) {
			this.errorAlert.destroy();
		}
		let isConfirmValid = true,
			isConfirmLength = true,
			error = "",
			newPass = this.$('.new-pass').val(),
			newPassConfirm = this.$('.new-pass-confirm').val();

		if (newPass !== newPassConfirm) {
			isConfirmValid = false;
			error += "Passwords do not match.  ";
			this.errorAlert = new PJQ.Alert(this.$('.error'), {
				type: 'danger',
				text: error
			});
		}

		if (newPass.trim().length < 7) {
			isConfirmLength = false;
			error += "Password is too short.";
			this.errorAlert = new PJQ.Alert(this.$('.error'), {
				type: 'danger',
				text: error
			});
		}
		PJQ.helpers.inputHelpers.setInputError(this.$('.new-pass-confirm'), isConfirmValid);
		PJQ.helpers.inputHelpers.setInputError(this.$('.new-pass'), isConfirmLength);
		if ((isConfirmValid && isConfirmLength)) {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'users'
					},
					{
						endpoint: 'resetpassword'
					},
				]),
				data: {
					password: newPass
				}
			}).post().success(_.bind(function (data) {
				if (data.success) {
					this.options.success = true;
					this.options.request = null;
					this.$('.password-group').hide();
					this.$('.modal-reset').hide();

					this.errorAlert = new PJQ.Alert(this.$('.error'), {
						type: 'success',
						text: "Password successfully changed!"
					});
				}
				else {
					if (data.error === "CURRENT_PASSWORD") {
						this.errorAlert = new PJQ.Alert(this.$('.error'), {
							type: 'danger',
							text: "New password matches current password"
						});
					}
				}
			}, this)).fail(_.bind(function () {
				this.options.success = false;
				this.render();
			}, this));
		}
	},
	showHide: function (e) {
		let target = $(e.currentTarget),
			showHide = this.$('.new-pass').attr('type'),
			showHideConfirm = this.$('.new-pass-confirm').attr('type');
		if (target.context.id === "btn-show-hide") {
			if (showHide === "password") {
				this.$('.new-pass').attr('type', "text");
				this.$('.show-hide span').removeClass('fa-eye-slash');
				this.$('.show-hide span').addClass('fa-eye')
			}
			else {
				this.$('.new-pass').attr('type', "password");
				this.$('.show-hide span').addClass('fa-eye-slash');
				this.$('.show-hide span').removeClass('fa-eye')
			}
		}
		if (target.context.id === "btn-show-hide-confirm") {
			if (showHideConfirm === "password") {
				this.$('.new-pass-confirm').attr('type', "text");
				this.$('.show-hide-confirm span').removeClass('fa-eye-slash');
				this.$('.show-hide-confirm span').addClass('fa-eye')
			}
			else {
				this.$('.new-pass-confirm').attr('type', "password");
				this.$('.show-hide-confirm span').addClass('fa-eye-slash');
				this.$('.show-hide-confirm span').removeClass('fa-eye')
			}
		}
	}
});
